/**
 * Bonus Service
 * Handles bonus-related API calls
 */

import { getUID } from '@/utils';

const ROLE_KEY = '8a37f45e02c57b489f9b5a9949154cf3b8c48540744185c463df5f79f25d9053';

/**
 * Fetch user bonus data
 */
export const fetchUserBonus = async () => {
  try {
    const userId = getUID();
    if (!userId) {
      throw new Error('User ID not available');
    }

    const response = await fetch('https://api.jackopot.com/bonus/userbonus', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'role-key': ROLE_KEY,
      },
      body: JSON.stringify({
        userid: userId,
        role: 'user',
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user bonus');
    }

    const data = await response.json();
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    }
    return null;
  } catch (error) {
    console.error('Error fetching user bonus:', error);
    throw error;
  }
};

/**
 * Fetch bonuses (daily, weekly, monthly)
 */
export const fetchBonuses = async () => {
  try {
    const userId = getUID();
    if (!userId) {
      throw new Error('User ID not available');
    }

    const response = await fetch(
      `https://api.jackopot.com/Userbonus/api/bonuses?userid=${userId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'role-key': ROLE_KEY,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch bonuses');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching bonuses:', error);
    throw error;
  }
};

/**
 * Fetch bonus redeem data
 */
export const fetchBonusRedeem = async () => {
  try {
    const userId = getUID();
    if (!userId) {
      throw new Error('User ID not available');
    }

    const response = await fetch('https://api.jackopot.com/bonus/user', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'role-key': ROLE_KEY,
      },
      body: JSON.stringify({
        userid: userId,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch bonus redeem data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching bonus redeem:', error);
    throw error;
  }
};

/**
 * Fetch bonus history
 */
export const fetchBonusHistory = async () => {
  try {
    const userId = getUID();
    if (!userId) {
      throw new Error('User ID not available');
    }

    const response = await fetch(
      `https://api.jackopot.com/Userbonus/api/bonus-history?userid=${userId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'role-key': ROLE_KEY,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch bonus history');
    }

    const data = await response.json();
    const claimedBonuses = data.history?.filter((item) => item.is_claimed === true) || [];
    return claimedBonuses;
  } catch (error) {
    console.error('Error fetching bonus history:', error);
    throw error;
  }
};

/**
 * Claim bonus
 */
export const claimBonus = async (bonusType) => {
  try {
    const userId = getUID();
    if (!userId) {
      throw new Error('User ID not available');
    }

    const response = await fetch(
      `https://api.jackopot.com/Userbonus/api/bonuses/claim/${bonusType}?userid=${userId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'role-key': ROLE_KEY,
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to claim bonus');
    }

    return data;
  } catch (error) {
    console.error('Error claiming bonus:', error);
    throw error;
  }
};

/**
 * Redeem bonus code
 */
export const redeemBonusCode = async (code) => {
  try {
    const userId = getUID();
    if (!userId) {
      throw new Error('User ID not available');
    }

    const response = await fetch('https://api.jackopot.com/bonus/redeem-bonus/redeem', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'role-key': ROLE_KEY,
      },
      body: JSON.stringify({
        userid: userId,
        code: code,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to redeem bonus code');
    }

    return data;
  } catch (error) {
    console.error('Error redeeming bonus code:', error);
    throw error;
  }
};
